import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import type { TestOrderViewModel } from '@/features/patient-record/types';

import { SectionHeading } from './SummaryItem';

const VISIBLE_LIMIT = 10;

interface OrdersTooltipProps {
  readonly orders: readonly TestOrderViewModel[];
}

export function OrdersTooltip({ orders }: OrdersTooltipProps): ReactElement {
  const { t } = useTranslation();
  const visible = orders.slice(0, VISIBLE_LIMIT);
  const overflow = orders.length - visible.length;

  return (
    <div className="space-y-1.5 min-w-[240px]">
      <SectionHeading
        text={t('patient.geneticSummary.tooltips.ordersTitle', {
          count: orders.length,
        })}
      />
      <ul className="space-y-1">
        {visible.map((order) => (
          <li key={order.id} className="flex items-center gap-2 text-xs">
            <span className="font-medium text-foreground truncate">
              {order.testName}
            </span>
            <span className="text-muted-foreground/80 text-[10px] ml-auto shrink-0">
              {t(`patient.testOrders.status.${order.status}`)}
            </span>
          </li>
        ))}
      </ul>
      {overflow > 0 && (
        <p className="text-[11px] text-muted-foreground">
          {t('patient.geneticSummary.tooltips.andMore', { count: overflow })}
        </p>
      )}
    </div>
  );
}
